export function isValidEmail(str?: string): boolean {
  if (!str) {
    return false;
  }

  // eslint-disable-next-line no-useless-escape
  return /^\S+@\S+\.\S+$/im.test(str);
}
